// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__6iNXa"};